// Renders the small channel chips under a campaign name.
// Matches the "Email · In-app" look in the dashboard prototype.

import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CHANNEL, OFFER } from '../../constants';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.NEU_600};
`;

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
`;

const Separator = styled.span`
  color: ${({ theme }) => theme.colors.NEU_300};
`;

const channelVariant = (channel, theme) => {
  const c = theme.colors;
  const labels = {
    [CHANNEL.EMAIL]: 'Email',
    [CHANNEL.NETWORK_UPSELL]: 'In-app',
  };
  return { bg: c.NEU_100, fg: c.NEU_600, label: labels[channel] ?? channel };
};

const offerLabel = (campaign, t) => {
  const { offer, discount, template } = campaign;
  if (offer === OFFER.DISCOUNT && discount?.percentage) {
    return t('campaigns.offerDiscount', { percent: discount.percentage, defaultValue: `Discount ${discount.percentage}%` });
  }
  if (offer === OFFER.INVITATION) return t('campaigns.offerInvitation', 'Invitation');
  if (offer === OFFER.NONE && !template) return t('campaigns.offerNone', 'No offer');
  if (template) {
    const labels = {
      promotional: 'Promotional',
      invitation: 'Invitation',
      discount: 'Discount',
      reengagement: 'Re-engagement',
      recommendation: 'Recommendation',
      announcement: 'Announcement',
    };
    return labels[template] ?? template;
  }
  return '';
};

const ChannelChips = ({ campaign, theme }) => {
  const { t } = useTranslation();
  const channels = campaign?.channels ?? [];
  const subtitle = offerLabel(campaign, t);

  return (
    <Row>
      {channels.map((ch) => {
        const { bg, fg, label } = channelVariant(ch, theme);
        return <Chip key={ch} $bg={bg} $fg={fg}>{label}</Chip>;
      })}
      {subtitle && (
        <>
          <Separator>·</Separator>
          <span>{subtitle}</span>
        </>
      )}
    </Row>
  );
};

export default ChannelChips;
